import { render, staticRenderFns } from "./DepreciationRule.vue?vue&type=template&id=2dd9ef9c"
import script from "./DepreciationRule.vue?vue&type=script&lang=js"
export * from "./DepreciationRule.vue?vue&type=script&lang=js"
import style0 from "./DepreciationRule.vue?vue&type=style&index=0&id=2dd9ef9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports